import { useDispatch, useSelector } from 'react-redux';
import { undoPanelState } from 'store/slices/PanelSlice';
import { AppDispatch, RootState } from 'store';
import { undoEditableFacets } from 'store/slices/RoofEditSlice';
import { undoLastObstruction } from 'store/slices/ObstructionUndoSlice';
import CustomUndoBtn from 'components/tool/Editor/ButtonDiv/UndoButton';

export default function UndoButton({ label, disabled }: { label?: string; disabled?: boolean }) {
	const dispatch = useDispatch<AppDispatch>();
	const { currentIndex:panelHistoryCurrentIndex, panelHistory, activePanelMode } = useSelector((state: RootState) => state.panelSlice.data);
	const { enableEditFacet, currentIndex:facetHistoryCurrentIndex, } = useSelector((state: RootState) => state.roofEditData.data);
	const { enableEditObs, deleteObstructionsMode } = useSelector((state: RootState) => state.toolNewPostions.data);
	const obstructionUndoStack = useSelector((state: RootState) => state.obstructionState.stack);
	const panelMode = activePanelMode && panelHistory.length > 0;
	const facetMode = enableEditFacet;
	const obsMode = enableEditObs && !deleteObstructionsMode;
	const show = panelMode || facetMode || obsMode;
	const shouldDisable = 
		disabled || 
		(panelMode && panelHistoryCurrentIndex <= 0) || 
		(facetMode && facetHistoryCurrentIndex <= 0) ||
		(obsMode && obstructionUndoStack.length <= 0);
	
	function handleClick() {
		if (obsMode) {
			dispatch(undoLastObstruction());
			return;
		}
		if(panelMode) {
			dispatch(undoPanelState());
		}
		if(facetMode) {
			dispatch(undoEditableFacets());
		}
	}

	if (show) {
		return (
			<CustomUndoBtn
				id="undo"
				disabled={shouldDisable}
				onClick={handleClick}
				label={label}
			/>
		);
	}

	return null;

}
